import clsx from "clsx"
import React from "react"
import "./Blank.css"

interface BlankProps extends React.HTMLAttributes<HTMLDivElement> {}

const Blank: React.FC<BlankProps> = props => {
    const {className, children, ...otherProps} = props

    return (
        <div className={clsx("blank-x5d9", className)} {...otherProps}>
            {children}
        </div>
    )
}

export default Blank
